import React from 'react';
import cn from 'classnames';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import { FORMATTING_CHOICES } from './constants';

const Formatting = ({ formatChoice, setFormatChoice }) => {
  return (
    <>
      <div
        className="formattingChoices"
        data-testid="LessonCreationModalFormatChoices"
      >
        {FORMATTING_CHOICES.map(choice => (
          <Text
            variant={TEXT_VARIANTS.BODY}
            component="label"
            htmlFor={`formattingChoice${choice.value}`}
            className={cn('formattingChoices-block', {
              'formattingChoices-block--active': formatChoice === choice.value,
            })}
            key={`formattingChoices${choice.value}`}
            tabIndex="0"
            onClick={() => setFormatChoice(choice.value)}
            onKeyDown={e => e.key === 'Enter' && setFormatChoice(choice.value)}
            data-testid={`learning-experience-${choice.value}`}
          >
            <input
              id={`formattingChoice${choice.value}`}
              type="radio"
              checked={formatChoice === choice.value}
              onChange={() => setFormatChoice(choice.value)}
              value={choice.value}
            />
            <strong>{choice.title}</strong>
            {choice.subheader}
          </Text>
        ))}
      </div>
    </>
  );
};

export default Formatting;
